import React from 'react';
import BrainLogo from '../components/BrainLogo';

export default function Manifesto({ navigate }) {
  return (
    <div style={{ fontFamily: 'Inter, -apple-system, sans-serif', minHeight: '100vh', background: '#0a0a0a' }}>

      {/* ── DARK HEADER ── */}
      <div style={{
        background: '#0a0a0a',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* Subtle orb */}
        <div style={{
          position: 'absolute', top: -60, right: -40,
          width: 320, height: 320, borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(10,156,133,0.10) 0%, transparent 70%)',
          filter: 'blur(40px)', pointerEvents: 'none',
        }} />
        <div className="hero-grid" />

        {/* ── FULL NAV (same as Landing) ── */}
        <nav style={{
          position: 'relative', zIndex: 20,
          padding: '18px 24px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>
          <button
            onClick={() => navigate('landing')}
            style={{ display: 'flex', alignItems: 'center', gap: 9, background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
          >
            <BrainLogo size={32} color="white" />
            <span style={{ color: 'white', fontWeight: 700, fontSize: 17, letterSpacing: '-0.3px' }}>
              Mindris
            </span>
          </button>

          <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <button onClick={() => navigate('landing')} className="landing-nav-link">
              How it works
            </button>
            {/* Manifesto is active — highlight it */}
            <button
              className="landing-nav-link"
              style={{ color: 'rgba(255,255,255,0.85)', cursor: 'default' }}
            >
              Manifesto
            </button>
            <a href="mailto:tylerkim1020@gmail.com" className="landing-nav-link" style={{ textDecoration: 'none' }}>
              Contact
            </a>
            <button
              onClick={() => navigate('login')}
              style={{
                background: 'rgba(255,255,255,0.07)',
                border: '1px solid rgba(255,255,255,0.12)',
                borderRadius: 8, color: 'rgba(255,255,255,0.75)',
                fontSize: 13, fontWeight: 500, padding: '7px 18px',
                cursor: 'pointer', fontFamily: 'Inter, sans-serif',
                transition: 'all 0.2s', marginLeft: 10,
              }}
            >Sign In</button>
          </div>
        </nav>

        {/* Page title */}
        <div style={{
          position: 'relative', zIndex: 10,
          maxWidth: 600, margin: '0 auto',
          padding: '40px 24px 24px',
        }}>
          <div style={{
            fontSize: 10, fontWeight: 700, textTransform: 'uppercase',
            letterSpacing: '2px', color: '#0a9c85', marginBottom: 18,
            display: 'flex', alignItems: 'center', gap: 10,
          }}>
            <span style={{ color: 'rgba(10,156,133,0.35)' }}>—</span>
            <span>Manifesto</span>
          </div>
          <h1 style={{
            fontSize: 'clamp(30px, 7vw, 46px)', fontWeight: 700,
            color: 'white', letterSpacing: '-1.2px', lineHeight: 1.12,
            fontFamily: 'Lora, Georgia, serif', margin: 0,
          }}>
            Why Mindris<br/>exists.
          </h1>
        </div>
      </div>

      {/* ── CONTENT ── */}
      <div style={{ maxWidth: 600, margin: '0 auto', padding: '16px 24px 110px' }}>

        <div className="manifesto-body" style={{
          fontFamily: 'Lora, Georgia, serif',
          fontSize: 18,
          color: '#b4b4b4',
          lineHeight: 1.9,
        }}>
          <p style={{ marginTop: 0 }}>
            My sister Audrey has Dup15q Syndrome, a rare genetic disorder that affects her ability
            to communicate, learn, and process the world around her. But what makes caring for
            Audrey hard isn't just the diagnosis. It's everything underneath it.
          </p>
          <p>
            It's knowing that a green iPad calms her down. That she'll rip up Korean picture books
            when she's frustrated and that's actually okay, it's what she needs. It's a thousand
            small, specific things that only the people closest to her have learned over years.
          </p>
          <p className="pull">
            That knowledge doesn't transfer easily.
          </p>
          <p>
            When Audrey goes to school, sees a new therapist, or spends time somewhere without us,
            the people caring for her are working with secondhand information. Notes. Forms. Phone
            calls to parents in the middle of a crisis. They're doing their best, but they're guessing.
          </p>
          <p>
            I saw this up close every summer at Camp Barnabas, a camp in Purdy, Missouri that gives
            people with intellectual and physical disabilities one week of real joy. Waterslides,
            archery, swimming, everything adapted so every camper can fully participate. I volunteered
            there every summer. And during those weeks, I watched caring, trained staff scramble
            during meltdowns, flipping through intake forms, calling parents, trying to piece
            together what triggered this and what might help. The information existed. It just wasn't
            where it needed to be, when it needed to be there.
          </p>
          <p className="pull">
            That's why I built Mindris.
          </p>
          <p>
            Mindris is an AI-powered caregiver support tool. You build a profile for the person
            you care for: their triggers, calming strategies, routines, the specific things that
            make their situation uniquely theirs. When something happens, you describe it and get
            real-time, personalized guidance in seconds. Not generic advice. Advice built around
            that one specific person.
          </p>
          <p>
            The system learns over time. Every interaction makes it more accurate, so a Camp
            Barnabas counselor, a classroom teacher, or a weekend respite caregiver can access the
            same depth of knowledge that a parent carries after years.
          </p>
          <p>
            Mindris is currently available as a web app at mindris.app, with a mobile app in
            active development.
          </p>
          <p className="closing">
            Every person is unique. The support they receive should be too.
          </p>
        </div>

        {/* Bottom "back" — subtle, in content area not header */}
        <div style={{ marginTop: 64, paddingTop: 28, borderTop: '1px solid #262626' }}>
          <button
            onClick={() => navigate('landing')}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 6,
              background: 'none', border: 'none', cursor: 'pointer',
              fontFamily: 'Inter, sans-serif', fontSize: 13, fontWeight: 500,
              color: '#6b6b6b', padding: 0, transition: 'color 0.15s',
            }}
            onMouseEnter={e => e.currentTarget.style.color = '#0a9c85'}
            onMouseLeave={e => e.currentTarget.style.color = '#6b6b6b'}
          >
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <polyline points="15 18 9 12 15 6"/>
            </svg>
            Back to home
          </button>
        </div>
      </div>

      {/* ── FOOTER ── */}
      <div style={{
        background: '#0a0a0a', padding: '32px 24px',
        textAlign: 'center', borderTop: '1px solid rgba(255,255,255,0.05)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 9, marginBottom: 12 }}>
          <BrainLogo size={22} color="#ffffff" />
          <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: 14, fontWeight: 600 }}>Mindris</span>
        </div>
        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.18)' }}>
          Built for caregivers, by caregivers.
        </div>
      </div>

    </div>
  );
}
